import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DermService } from 'src/app/includes/derm/derm.service';

@Component({
  selector: 'app-derm-report-viewer',
  templateUrl: './derm-report-viewer.component.html',
  styleUrls: ['./derm-report-viewer.component.css']
})
export class DermReportViewerComponent implements OnInit {
  followUpData: { followUpId: any; f_type: any; title: any; template: any; };
  consultation: { status: any; assessmentAndRecommendation: any; };
  caseDiagnoses: any;

  constructor(
    public dialogRef: MatDialogRef<DermReportViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dermService: DermService,
  ) { 
    console.log(data);
    this.followUpData = {
      followUpId: this.data.case_FollowUpTemplates?.followUpId,
      f_type: this.data.case_FollowUpTemplates?.f_type,
      title: this.data.case_FollowUpTemplates?.title,
      template: this.data.case_FollowUpTemplates?.template
    };
  
    this.consultation = {
      status: this.data.case_consultation?.status,
      assessmentAndRecommendation: this.data.case_consultation?.assessmentAndRecommendation
    };
  
    this.caseDiagnoses = this.data.case_diagnoses.map(diagnosis => ({
      diagnosisId: diagnosis?.diagnosisId,
      icd: diagnosis?.icd,
      name: diagnosis?.name
    }));
  }

  ngOnInit(): void {

  }

  downloadPDF() {

  }

}
